<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = ["android","ios","other"].map(v => {
			return { value: v, label: v.toUpperCase() };
		});
		return{
			options,
		}
	},
	props:['value'],
}
</script>

